//  document.addEventListener("DOMContentLoaded", function () {
//   console.log("luxwatches", window.luxwatches)
//   // Attach event listener to "Add to Cart" button
//    function custmaddtocat(e){
//         console.log("luxwatches", window.luxwatches)
//       var variantId = this.getAttribute('data-variant-id');
//       // AJAX request to add product to the cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       })
//       .then(response => response.json())
//       .then(data => {
       
//         // You can update the cart UI here, e.g., showing a confirmation message or updating the cart count
//         updateCartCount(); // Optional: function to update the cart count
//         window.luxwatches.updateDropdownCart();
       
        
//       })
//       .catch(error => {
//         console.error('Error adding product to cart:', error);
//       });
//     }
 
// })
// setTimeout(() => {
//   Array.from(document.getElementsByClassName("uuuuuuu")).forEach((item) => {
//     item.addEventListener("click", () => {
//       alert("uuuuu");
//     });
//   });
// }, 1000);








function custmaddtocat(e){
  console.log(window.luxwatches,"luxwatches")
   let newarr=e.target.parentElement;
 let quick=newarr.querySelector(".customize-quick-view");
    if(quick){
     let quickclicked=quick.click();
      setTimeout(()=>{
         let addtocart=document.querySelector(".added-to-beg");
         let closebtn=document.querySelector(".close-modal");
        console.log(closebtn,"closebtn")
        console.log("add to cart before")
       if(addtocart){
          addtocart.click();
         closebtn.click()
         document.querySelector(".js").style.overflow="scroll"
         console.log("add to cart after")
       }else{
         console.log("not inside cart")
       }
      },2000)
   }else{
     console.log("not found")
   }
   
  }